/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */

export const metadata = {
  title: 'Extras'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Extras`}</h1>
    <p>{`The following pages can be seen as bonus guides or "Extras". They are a little more advanced, and could be explored if you want to challenge yourself after the workshop.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
